import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home-item-icon1",
  "use": "icon-home-item-icon1-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-home-item-icon1\">\n<path id=\"icon-home-item-icon1_编辑\" d=\"M9.4,13.6l-4.5,2.3c-0.6,0.2-0.9-0.2-0.7-0.7l2.3-4.5c0-0.2,0.1-0.3,0.2-0.6L13,3.9H3.1c-0.8,0-1.5,0.7-1.5,1.5\n\tV17c0,0.8,0.7,1.5,1.5,1.5h11.7c0.8,0,1.5-0.7,1.5-1.5V7L10,13.3C9.8,13.5,9.7,13.5,9.4,13.6z M5.1,14.4c-0.1,0.1,0,0.3,0.1,0.3\n\ts0.2,0,0.2,0l2.8-1.7l-1.5-1.5L5.1,14.4z M15.8,6l0.5-0.5V5.2c0-0.8-0.7-1.5-1.5-1.5h-0.3l-0.3,0.3L15.8,6z M7.4,10.8\n\tc0.2,0.2,1.1,1.1,1.8,1.8l5.9-5.9l-1.8-1.8L7.4,10.8z M18.1,3.8l-1.8-1.8c-0.5-0.5-1-0.5-1.5,0l0,0L13,3.8h1.5l0.7-0.7\n\tc0.2-0.2,0.6-0.2,0.7,0l1.1,1.1c0.2,0.2,0.2,0.6,0,0.7l-0.7,0.7V7l1.8-1.8C18.4,4.9,18.4,4.2,18.1,3.8L18.1,3.8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home-item-icon1.svg
// module id = Fasd
// module chunks = 97